import logo from "../images/logo.png";
import home from "../images/home.png";
import user from "../images/user.png";
import homework from "../images/homework.png";
import score from "../images/score.png";
import caffe from "../images/caffe.svg"
import { useState, useEffect } from "react";
import "../styles/navbar.css"
import { FaUser } from "react-icons/fa";
import { Link, NavLink, useNavigate } from "react-router-dom";
import api from "../pages/api"
import { MdLogout } from "react-icons/md";

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [profile, setProfile] = useState(null);
    const [code, setCode] = useState(null);
    const navigate = useNavigate();

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);

        document.body.style.overflow = !isMobileMenuOpen ? 'hidden' : 'auto';
    };
 useEffect(() => {
    api.get('student/api/v1/student-scores/me/').then((res) => {
        setProfile(res.data.my_score);  // ← اضافه کردن .my_score
    }).catch((err) => {
        console.error('خطا در گرفتن اطلاعات پروفایل:', err);
    })
}, [])


   

    const handleLogout = async () => {
        try {
            const refreshToken = localStorage.getItem("refreshToken");

            if (!refreshToken) {
                localStorage.clear();
                navigate("/login");
                window.location.reload(); // <-- force refresh
                return;
            }

            await api.post("manager/api/v1/logout", { refresh: refreshToken });

            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");

            navigate("/login");
            window.location.reload(); // <-- refresh after navigation
        } catch (error) {
            console.error("Logout failed:", error);
            localStorage.clear();
            navigate("/login");
            window.location.reload(); // <-- even if error
        }
    };


    return (<div className="mx-3">

        <div className="d-lg-block mb-3 mx-5  d-none" style={{ borderBottom: "1px solid #ccc" }}>
            <div className="row">
                <div className="col-9 p-3">
                    {profile?.profile_image ? (
                        <img
                            src={`${profile.profile_image}`}
                            alt={`${profile.full_name}`}
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                objectFit: 'cover'
                            }}

                        />
                    ) : (
                        <FaUser style={{ fontSize: '40px', color: '#888' }} />
                    )}
                    <span className="mt-4"> {profile?.full_name} </span>
                    
                </div>

                <div className="col-3">
                    <a href="https://pythonteekcafe.ir/user" className="d-flex">
                        <div className="">
                            <img src={caffe} width={70} height={70} />


                        </div>
                        <div className="mt-3">
                            <div style={{ color: "rgba(43, 167, 105, 1)", width: "115px" }}>کافه برنامه نویسی</div>
                            <div style={{ fontSize: "13px", color: "#777" }}>
                                امتیاز: {profile?.cafe_programming_score ?? 0}
                            </div>
                        </div>

                    </a>

                </div>
            </div>

        </div>
        <div className="header header-top-phone d-block d-lg-none">
            <div className="header-phone-inner">
                <div className="mobile-menu ">
                    <button
                        type="button"
                        className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
                        onClick={toggleMobileMenu}
                        aria-label="mobile-menu"
                    >
                        <span className="bars" >
                            <span className="bar " ></span>
                            <span className="bar"></span>
                            <span className="bar"></span>
                        </span>
                    </button>
                </div>
                <div className="mt-3" style={{ fontSize: "25px" }}>
                    <span >ythonteek</span><img src={logo} width={37} height={37} />
                </div>

                <div className="mt-2">
                    {profile?.profile_image ? (
                        <img
                            src={`${profile.profile_image}`}
                            alt={`${profile.full_name}`}
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                objectFit: 'cover'
                            }}

                        />
                    ) : (
                        <FaUser style={{ fontSize: '40px', color: '#888' }} />
                    )}
                </div>
            </div>
        </div>
        {/* Mobile Sidebar */}
        <div className={`mobile-sidebar ${isMobileMenuOpen ? 'active' : ''}`}>
            <div className="sidebar-content">

                <div className="branding ">
                    <a href="/" rel="home" className="link fs-1 fw-bold">
                        ythonteek

                        <img src={logo} width={35} height={35} />

                    </a>
                </div>

                <button
                    className="close-button "
                    onClick={toggleMobileMenu}
                    aria-label="Close menu"
                >
                    ×
                </button>




                <div className="sidebar-menu">
                    <div style={{ position: "relative" }}>
                        <NavLink
                            to="/"
                            className={({ isActive }) =>
                                `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`
                            }
                        >
                            <img src={home} width={30} height={30} alt="Home" />
                            <span className="mx-2">خونه</span>
                        </NavLink>

                    </div>

                    <div style={{ position: "relative" }}>
                        <NavLink
                            to="/about"
                            className={({ isActive }) =>
                                `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`
                            }
                        >
                            <img src={user} width={30} height={30} alt="Home" />
                            <span className="mx-2">درباره من</span>
                        </NavLink>

                    </div>
                    <div style={{ position: "relative" }}>
                        <NavLink
                            to="/homework"
                            className={({ isActive }) =>
                                `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`
                            }
                        >
                            <img src={homework} width={30} height={30} alt="Home" />
                            <span className="mx-2">تکالیف و جزوه</span>
                        </NavLink>

                    </div>
                    <div style={{ position: "relative" }}>
                        <NavLink
                            to="/score"
                            className={({ isActive }) =>
                                `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`
                            }
                        >
                            <img src={score} width={30} height={30} alt="Home" />
                            <span className="mx-2">مدارک و کارنامه ها</span>
                        </NavLink>

                    </div>
                    <div style={{ position: "relative" }}>
                        <NavLink
                            to="/roadmap"
                            className={({ isActive }) =>
                                `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`
                            }
                        >
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRulee="evenodd" d="M15 2.5C20.8925 2.5 23.8387 2.5 25.6688 4.33C26.2987 4.96 26.7125 5.7225 26.9837 6.69125L6.69125 26.9837C5.7225 26.7125 4.96 26.2987 4.33 25.6688C2.5 23.84 2.5 20.8925 2.5 15C2.5 9.1075 2.5 6.16125 4.33 4.33C6.1625 2.5 9.1075 2.5 15 2.5ZM6.875 10.9462C6.875 13.1775 8.27125 15.7812 10.45 16.7125C10.9575 16.9288 11.5425 16.9288 12.05 16.7125C14.2288 15.7812 15.625 13.1775 15.625 10.9462C15.625 8.6975 13.6663 6.875 11.25 6.875C8.83375 6.875 6.875 8.6975 6.875 10.9462Z" fill="rgba(43, 167, 105, 1)" />
                                <path d="M13.125 11.25C13.125 11.7473 12.9275 12.2242 12.5758 12.5758C12.2242 12.9275 11.7473 13.125 11.25 13.125C10.7527 13.125 10.2758 12.9275 9.92417 12.5758C9.57254 12.2242 9.375 11.7473 9.375 11.25C9.375 10.7527 9.57254 10.2758 9.92417 9.92417C10.2758 9.57254 10.7527 9.375 11.25 9.375C11.7473 9.375 12.2242 9.57254 12.5758 9.92417C12.9275 10.2758 13.125 10.7527 13.125 11.25Z" fill="rgba(43, 167, 105, 1)" />
                                <path opacity="0.5" d="M27.3626 8.96497C27.5001 10.5412 27.5001 12.5075 27.5001 15C27.5001 20.1675 27.5001 23.0687 26.2664 24.9387L18.8251 17.5L27.3626 8.96497ZM24.9401 26.265L17.5014 18.8262L8.96387 27.3612C10.5414 27.5 12.5076 27.5 15.0014 27.5C20.1689 27.5 23.0701 27.5 24.9401 26.265Z" fill="rgba(43, 167, 105, 1)" />
                            </svg>
                            <span className="mx-2"> نقشه راه</span>
                        </NavLink>

                    </div>
                    <div style={{ position: "relative" }} onClick={handleLogout}>
                        <NavLink
                            to="/login"
                            className={({ isActive }) =>
                                `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`
                            }
                        >
                            <MdLogout style={{ fontSize: "30px" }} />
                            <span className="mx-2">   بیرون رفتن  </span>
                        </NavLink>

                    </div>


                </div>

            </div>
        </div>

    </div>);
}

export default Navbar;